import React, { useState } from 'react';
import { dispatcher } from 'dispatcher';

import { Timer } from 'js/app/components/common/Timer';
import { Button } from 'js/components/common/Button';

import { GAME_LAUNCH_TYPE, useGameLaunch } from 'js/app/components/main/Games/hooks/useGameLaunch';
import { useInMobile } from 'js/app/hooks/device/hooks/useMediaQuery';
import { clsx } from 'js/app/utils/clsx.util';
import { useTranslations } from 'js/hooks/i18n';
import { useFormatter } from 'js/hooks/useFormatter';

import style from './BingoTile.scss';

export const BingoTile = ({ gameData, viewModeInline }) => {
    const isMobile = useInMobile();
    const { formatCurrency } = useFormatter();
    const t = useTranslations('playtech.mobile.system.bingo.');
    const [isButtonLocked, setButtonLocked] = useState(false);
    const launchGame = useGameLaunch({
        code: gameData.name,
        gameLaunchType: GAME_LAUNCH_TYPE.BingoRoom,
        bingoGameType: gameData.bingoGameType,
        cb: () => setButtonLocked(false)
    });

    // Using disabled state to prevent double click when temp token loading
    const launchHandler = () => {
        if (!isButtonLocked) {
            setButtonLocked(true);
            launchGame();
        }
    };

    const backgroundImage = `url(${gameData[isMobile ? 'mobileImageURLs' : 'imageURLs']?.c1x1})`;

    const getAmount = (amount) => formatCurrency(amount / 100, { currencyCode: 'GBP' });

    const handlerEndTime = () => {
        dispatcher.dispatch('removeBingoGame', gameData.name);
    };

    return (
        <div
            className={viewModeInline ? style.inlineContainer : style.container}
            onClick={launchHandler}
        >
            <div className={clsx(style.ballIcon, style[`ball${gameData.numberOfBalls}`])} />

            <div className={style.content}>
                <div className={style.image} style={{ backgroundImage }} />

                <div className={style.infoWrapper}>
                    <div className={style.name}>
                        {gameData.jackpotAmount
                            ? (
                                <>
                                    <span className={style.jackpotIcon} />

                                    {getAmount(gameData.jackpotAmount)}
                                </>
                            )
                            : gameData.displayName
                        }
                    </div>

                    <div className={style.win}>
                        <span className={style.priceIcon} />

                        {getAmount(gameData.prizeInitialAmount).replace(' ', '')}
                    </div>

                    <div className={style.ticket}>
                        <span className={style.ticketIcon} />

                        {getAmount(gameData.cardPrice).replace(' ', '')}
                    </div>

                    <div className={style.players}>
                        <span className={style.playersIcon} />

                        {gameData.numberOfPlayers || 0}
                    </div>
                </div>
            </div>

            <Button
                size="normal"
                disabled={isButtonLocked}
                className={style.playButton}
            >
                {t('cta-prefix')}&nbsp;

                <Timer
                    isCheckDays
                    isCheckHours
                    isDaysLabel={false}
                    isTimeLabel={false}
                    countTo={gameData.clearTime}
                    handlerEndTime={handlerEndTime}
                    classNames={{ container: style.containerTimer }}
                />
            </Button>
        </div>
    );
};
